<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <ul>
          <li><a href="https://www.gcdeveye.com/">Company</a></li>
          <li>
            <a href="https://www.gcdeveye.com/request-an-appointment/">Appointment</a>
          </li>
          <li><a href="https://www.facebook.com/gcdeveyecenter/">Social</a></li>
        </ul>
      </nav>

      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }}
        <a href="https://www.globechek.com" target="_blank" rel="noopener">
          <span style="">Globe</span>
          <span style="font-weight:bold;">Chek</span>
        </a>
        <span style="padding-left: 10px; font-size: 12px;">
          &nbsp;Inc. What we see
          <i class="material-icons">remove_red_eye</i> may save your sight!</span
        >
      </div>
    </div>
  </footer>
</template>
<script>
export default {}
</script>
<style></style>
